import React from 'react';
import { Card, Badge } from './ui';
import { CheckCircle, Book, BookOpen, BookMarked, Library, Notebook, BookType, Gift, Sparkles } from 'lucide-react';
export function Product() {
  const tomos = [{
    icon: <Book className="w-8 h-8 text-brand-400" data-id="element-92" data-mp="28cvgw0iwb96v" />,
    color: 'bg-brand-500/10 border-brand-500/20',
    title: 'TOMO 1 — Reiki de Emergencia',
    subtitle: '(Ansiedad y Pánico)',
    desc: 'Aplicalo cuando sientas que la ansiedad o el pánico empiezan a superarte y necesitás recuperar la calma.'
  }, {
    icon: <BookOpen className="w-8 h-8 text-brand-300" data-id="element-93" data-mp="2d8armjllwoz2" />,
    color: 'bg-brand-500/10 border-brand-500/20',
    title: 'TOMO 2 — Reiki para Dormir',
    subtitle: '(Insomnio)',
    desc: 'Seguí este protocolo antes de dormir para bajar el pensamiento acelerado y descansar con mayor tranquilidad.'
  }, {
    icon: <BookMarked className="w-8 h-8 text-amber-400" data-id="element-94" data-mp="2w0wh8m5x7jb7" />,
    color: 'bg-amber-500/10 border-amber-500/20',
    title: 'TOMO 3 — Escudo Energético',
    subtitle: '(Protección)',
    desc: 'Ideal si sentís que absorbés la energía de otras personas y terminás agotado emocionalmente.'
  }, {
    icon: <Library className="w-8 h-8 text-brand-400" data-id="element-95" data-mp="25htt7jr7h39g" />,
    color: 'bg-brand-500/10 border-brand-500/20',
    title: 'TOMO 4 — Reiki de la Abundancia',
    subtitle: '(Dinero)',
    desc: 'Trabajá los bloqueos internos que hoy afectan tu relación con el dinero y la prosperidad.'
  }, {
    icon: <Notebook className="w-8 h-8 text-brand-300" data-id="element-96" data-mp="2jhkzszfe7hdf" />,
    color: 'bg-brand-500/10 border-brand-500/20',
    title: 'TOMO 5 — Reiki para Corazones Rotos',
    subtitle: '(Rupturas)',
    desc: 'Pensado para ayudarte a soltar una relación, cerrar una etapa y recuperar tu paz emocional.'
  }, {
    icon: <BookType className="w-8 h-8 text-amber-400" data-id="element-97" data-mp="2xakgv5utpjn3" />,
    color: 'bg-amber-500/10 border-amber-500/20',
    title: 'TOMO 6 — Reiki del Renacer',
    subtitle: '(Autoestima)',
    desc: 'Reconectá con tu autoestima, fortalecé tu confianza y empezá una nueva etapa.'
  }];
  return <section className="py-12 px-4 bg-slate-900/30 pt-[4px] pb-[4px]" data-id="element-98" data-mp="y5kgb8sj59it">
      <div className="max-w-5xl mx-auto" data-id="element-99" data-mp="1bw61x59dbxke">
        <div className="text-center mb-10" data-id="element-100" data-mp="1bwxx4ez1zta5">
          <Badge variant="success" className="mb-4" data-id="element-101" data-mp="1by0iy8hir5j7">
            PUNTO DIGITAL™ — MEGAPACK REIKI
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-102" data-mp="1lu3o7n7o3kad">
            6 Protocolos + 5 Bonos
          </h2>
          <p className="text-xl text-slate-400" data-id="element-103" data-mp="1gu7hhg7l5er4">
            Todo para empezar tu transformación energética.
          </p>
          <div className="flex flex-wrap justify-center gap-2 mt-6 text-sm font-medium text-brand-400" data-id="element-104" data-mp="1uuib2r0a57fz">
            <span data-id="element-105" data-mp="1pwqirvvq3jb9">Calma</span> <span className="text-slate-600" data-id="element-106" data-mp="1ptunygf69ar1">→</span>
            <span data-id="element-107" data-mp="i275wuyi5ea">Descanso</span> <span className="text-slate-600" data-id="element-108" data-mp="hiy75naarce">→</span>
            <span data-id="element-109" data-mp="3rnk5r481j2ta">Protección</span> <span className="text-slate-600" data-id="element-110" data-mp="3rodeubuh24el">→</span>
            <span data-id="element-111" data-mp="3rpohg8c6l644">Abundancia</span> <span className="text-slate-600" data-id="element-112" data-mp="274rftl29bg5f">→</span>
            <span data-id="element-113" data-mp="2761fgeorcwe6">Sanación</span> <span className="text-slate-600" data-id="element-114" data-mp="277m1th0x590y">→</span>
            <span data-id="element-115" data-mp="2c31brxvt2ks3">Renacer</span>
          </div>
        </div>

        <div className="mb-10" data-id="element-116" data-mp="1yd7lrc8kdugs">
          <h3 className="text-xl font-bold text-white mb-5 flex items-center gap-3" data-id="element-117" data-mp="1ybwm9om5j8vh">
            <Sparkles className="w-8 h-8 text-brand-400" data-id="element-118" data-mp="22drhqcheis1c" /> 6 PROTOCOLOS
            COMPLETOS
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-119" data-mp="1odqif1gsbsnz">
            {tomos.map((tomo, i) => <Card key={i} className={`border ${tomo.color}`} data-id="element-120" data-mp="1te4q2ieh50lh" data-mpi={i}>
                <div className="flex items-start gap-4" data-id="element-121" data-mp="1fe3hshvvqqvz">
                  <div className="p-3 bg-slate-900 rounded-xl shrink-0" data-id="element-122" data-mp="1ffocc7i729tu">
                    {tomo.icon}
                  </div>
                  <div data-id="element-123" data-mp="1jhi7k09melmm">
                    <h4 className="font-bold text-white text-lg mb-1" data-id="element-124" data-mp="39rl6w9bxnvt4">
                      {tomo.title}
                    </h4>
                    <p className="text-brand-400 text-sm font-medium mb-3" data-id="element-125" data-mp="3dsevl4x79en2">
                      {tomo.subtitle}
                    </p>
                    <p className="text-slate-400 text-sm leading-relaxed" data-id="element-126" data-mp="2p0pprgz5w1fb">
                      {tomo.desc}
                    </p>
                  </div>
                </div>
              </Card>)}
          </div>
        </div>

        <Card className="bg-slate-900" data-id="element-127" data-mp="2a6kusyh30p3p">
          <h4 className="font-bold text-xl text-white mb-6" data-id="element-128" data-mp="2a5jjqu02g2lz">
            Cada protocolo incluye:
          </h4>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-129" data-mp="266aplo1462pw">
            {['Paso a paso.', 'Prácticas guiadas.', 'Ejercicios.', 'Aplicación inmediata.', 'Consejos prácticos.'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-130" data-mp="1rgv2ci0skfey" data-mpi={i}>
                <CheckCircle className="w-5 h-5 text-brand-400 shrink-0 mt-0.5" data-id="element-131" data-mp="1mgql2ps27gno" />
                <span className="text-slate-300" data-id="element-132" data-mp="1ievjdk67v19d">{item}</span>
              </div>)}
          </div>
        </Card>
      </div>
    </section>;
}
export function Bonuses() {
  const bonuses = [{
    title: 'Tarjetero de Protocolos Express',
    desc: 'Recordatorios prácticos para acompañarte cuando necesites una pausa de calma.',
    value: '$8.000'
  }, {
    title: 'Calendario de Aplicación de 21 Días',
    desc: 'Una guía diaria y clara para convertir tu práctica en un hábito de bienestar.',
    value: '$8.000'
  }, {
    title: 'Guiones de Meditación para Leer',
    desc: 'Textos simples para guiar tus momentos de presencia y conexión interior.',
    value: '$9.000'
  }, {
    title: 'Test de Diagnóstico Energético',
    desc: 'Una herramienta para reconocer qué aspecto de tu energía necesita atención.',
    value: '$8.000'
  }, {
    title: 'Guía Rápida de Autotratamiento',
    desc: 'Una referencia accesible para volver a vos en cualquier momento del día.',
    value: '$9.000'
  }];
  return <section className="py-12 px-4" data-id="element-133" data-mp="2olvlcwyi7hp4">
      <div className="max-w-5xl mx-auto" data-id="element-134" data-mp="2oku0k0rorgu7">
        <div className="text-center mb-8" data-id="element-135" data-mp="2ojsq9yihuydj">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 flex items-center justify-center gap-3" data-id="element-136" data-mp="2kl3do85a5kuy">
            <Gift className="w-9 h-9 text-brand-400" data-id="element-137" data-mp="2yandb53ke201" />5 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-brand-400 font-bold uppercase tracking-widest" data-id="element-138" data-mp="2tcc3gud9rrht">
            Todo lo que necesitás para aplicar correctamente los protocolos desde el primer día.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-4 mb-8" data-id="element-139" data-mp="21mh8oi6n79lr">
          {bonuses.map((bono, i) => <Card key={i} className={`relative overflow-hidden group hover:border-brand-500/50 transition-colors lg:col-span-2 ${i === 3 ? 'lg:col-start-2' : ''}`} data-id="element-140" data-mp="2fms3txezjacq" data-mpi={i}>
              <div className="absolute top-0 right-0 bg-brand-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-141" data-mp="3qyj4juad71pf">
                BONO {i + 1}
              </div>
              <h4 className="font-bold text-white text-lg mb-3 pr-12 mt-2" data-id="element-142" data-mp="17sgp2srxnags">
                {bono.title}
              </h4>
              <p className="text-slate-400 text-sm mb-6" data-id="element-143" data-mp="1cu622dypty7i">{bono.desc}</p>
              <div className="mt-auto pt-4 border-t border-slate-800 flex justify-between items-center" data-id="element-144" data-mp="ytvb7axeojmc">
                <span className="line-through text-slate-500 text-sm" data-id="element-145" data-mp="13sy45x042zdy">
                  Valor {bono.value}
                </span>
                <span className="text-brand-400 font-bold" data-id="element-146" data-mp="1riakrhxrq9qa">GRATIS</span>
              </div>
            </Card>)}
        </div>

        <div className="bg-gradient-to-r from-brand-900/50 to-brand-800/50 border border-brand-500/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-147" data-mp="1hrxs12fsva92">
          <p className="text-slate-300 mb-2" data-id="element-148" data-mp="1mp7sdd4q96bo">Valor total bonos</p>
          <p className="text-4xl font-black text-white mb-2 line-through decoration-red-500/50" data-id="element-149" data-mp="2ag3dxsilb5ah">
            $51.000
          </p>
          <p className="text-2xl font-bold text-brand-400" data-id="element-150" data-mp="2f8mrwql6w2ft">
            → GRATIS con tu Megapack Reiki
          </p>
        </div>
      </div>
    </section>;
}